import { useLoginContext } from '@openeducation/oe-rn-providers';
import React, { useState } from 'react';

import { OrganismTestId } from '../../constants/test-id';
import FormFooter from '../../molecules/form-footer/form-footer';
import TextInputWithLink from '../../molecules/text-input-with-link/text-input-with-link';
import { mt } from '../../style-utils';

export interface LoginFormProps {
  onRecoverPassword: () => void;
  onRecoverUsername: () => void;
  labels: {
    usernameLabel: string;
    usernameLink: string;
    passwordLabel: string;
    passwordLink: string;
    buttonSubmit: string;
  };
}

export const LoginForm: React.FC<LoginFormProps> = ({
  onRecoverPassword,
  onRecoverUsername,
  labels,
}) => {
  const { loginWithUsernameAndPassword, loginError, isLoading } =
    useLoginContext();

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const handleFieldChange = (value: string, name?: string) => {
    if (name) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const { username, password } = formData;

  return (
    <>
      <TextInputWithLink
        linkText={labels.usernameLink}
        label={labels.usernameLabel}
        name="username"
        autoComplete="username"
        textContentType="username"
        onLinkPress={onRecoverUsername}
        onChangeText={handleFieldChange}
        value={username}
        testID={OrganismTestId.USERNAME_INPUT}
      />
      <TextInputWithLink
        linkText={labels.passwordLink}
        label={labels.passwordLabel}
        name="password"
        autoComplete="password"
        textContentType="password"
        onLinkPress={onRecoverPassword}
        onChangeText={handleFieldChange}
        value={password}
        containerStyle={mt(32)}
        testID={OrganismTestId.PASSWORD_INPUT}
        secure
      />
      <FormFooter
        buttonSubmit={{
          onPress: () => loginWithUsernameAndPassword(username, password),
          loading: isLoading,
          label: labels.buttonSubmit,
        }}
        error={loginError}
      />
    </>
  );
};

export default LoginForm;
